
import * as React from 'react';
import { AppBar } from './AppBar';
import { Route, Switch } from 'react-router';
import Loading from './Loading';
import MainMenuPage from './MainMenuPage';
import NotFoundPage from './NotFoundPage';
import SelectSitePage from './SelectSitePage';
import SystemStateMessageView from './SystemStateMessageView';
import InferencePage from './InferencePage';
import KansatuKirokuListPage from './KansatuKirokuListPage';
import EditKansatsuKirokuPage from './EditKansatsuKirokuPage';
import SelectSiteSubdivPage from './subdiv/SelectSiteSubdivPage';
import KansatuKirokuSubdivListPage from './subdiv/KansatuKirokuSubdivListPage';
import EditKansatsuKirokuSubdivPage from './subdiv/EditKansatsuKirokuSubdivPage';
import InferenceSubdivPage from './subdiv/InferenceSubdivPage';
import FullArchiveDownloadPage from './FullArchiveDownloadPage';
import FullArchiveDownloadSubdivPage from './subdiv/FullArchiveDownloadSubdivPage';
import FullArchiveDownloadObsrecPage from './obsrec/FullArchiveDownloadObsrecPage';
import SelectSiteObsrecPage from './obsrec/SelectSiteObsrecPage';
import KansatuKirokuObsrecListPage from './obsrec/KansatuKirokuObsrecListPage';
import InferenceObsrecPage from './obsrec/InferenceObsrecPage';
import EditKansatsuKirokuObsrecPage from './obsrec/EditKansatsuKirokuObsrecPage';
interface OwnProps {
}

const RootPage: React.SFC<OwnProps> = (props: OwnProps) => {
  return (
    <div>
      <AppBar />
      <Switch>
        <Route exact path='/' component={MainMenuPage} />
        <Route exact path='/sitelist' component={SelectSitePage} />
        <Route exact path='/subdiv/sitelist' component={SelectSiteSubdivPage} />
        <Route exact path='/subdiv/kansatsukiroku/:koujibangou' component={KansatuKirokuSubdivListPage} />
        <Route exact path='/subdiv/kansatsukiroku/:koujibangou/__NEW__' component={InferenceSubdivPage} />
        <Route exact path='/subdiv/kansatsukiroku/:koujibangou/:key' component={EditKansatsuKirokuSubdivPage} />
        <Route exact path='/kansatsukiroku/:koujibangou' component={KansatuKirokuListPage} />
        <Route exact path='/kansatsukiroku/:koujibangou/__NEW__' component={InferencePage} />
        <Route exact path='/kansatsukiroku/:koujibangou/:key' component={EditKansatsuKirokuPage} />
        <Route exact path='/fullarchivedownload/:koujibangou' component={FullArchiveDownloadPage} />
        <Route exact path='/fullarchivedownloadsubdiv/:koujibangou' component={FullArchiveDownloadSubdivPage} />
        <Route exact path='/fullarchivedownloadobsrec/:koujibangou' component={FullArchiveDownloadObsrecPage} />
        <Route exact path='/obsrec/sitelist' component={SelectSiteObsrecPage} />
        <Route exact path='/obsrec/kansatsukiroku/:koujibangou' component={KansatuKirokuObsrecListPage} />
        <Route exact path='/obsrec/kansatsukiroku/:koujibangou/__NEW__' component={InferenceObsrecPage} />
        <Route exact path='/obsrec/kansatsukiroku/:koujibangou/:key' component={EditKansatsuKirokuObsrecPage} />
        {/* 無効なURL */}
        <Route component={NotFoundPage}/>
      </Switch>
      <SystemStateMessageView />
      <Loading />
    </div>
  );
}
export default RootPage;




// WEBPACK FOOTER //
// ./src/components/RootPage.tsx